export default __webpack_public_path__ + "static/media/1232.fb3441d4.png";